<template>
  <div class="w-full h-full relative">
    <Header :title="'Meine Kurse'" :hasBack="false" />
    <content-container class="content-container-big">
      <div class="flex flex-row flex-wrap items-center justify-start mb-3">
        <filter-tab
          :filter="filter"
          :isActive="state.activeFilterId === filter.id"
          v-for="filter in state.filters"
          :key="filter.id"
          @click="state.activeFilterId = filter.id"
        />
      </div>
      <div class="w-full max-w-3xl">
        <list-transition>
          <course-item
            class="opacity-100 list-transition-item"
            :course="course"
            v-for="(course, index) in filteredCourses"
            :key="index"
            @click="
              $router.push({
                name: 'CourseShow',
                params: { id: course.id },
              })
            "
          />
          <div
            v-if="filteredCourses.length == 0 && activeFilter != null"
            class="text-grey-dark text-lg my-10 list-transition-item"
          >
            <template v-if="activeFilter.text == 'Alle Kurse'">
              Sie haben noch keine aktiven Kurse.
            </template>
            <template v-if="activeFilter.text == 'Aktive'">
              Sie haben aktuell keine aktiven Kurse!
            </template>
            <template v-if="activeFilter.text == 'Abgeschlossene'">
              Sie haben noch keine abgeschlossenen Kurse!
            </template>
            <template v-if="activeFilter.text == 'Merkliste'">
              Sie haben keine Kurse auf Ihrer Merkliste!
            </template>
          </div>
        </list-transition>

        <ad-component />
      </div>
    </content-container>
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import ContentContainer from "../../components/layout/ContentContainer.vue";
import Header from "../../components/layout/Header.vue";
import ListTransition from "../../components/transitions/ListTransition.vue";
import { COURSE_TYPES, HELPER_TYPES, STORE_TYPES } from "../../store/types";
import AdComponent from "./AdComponent.vue";
import CourseItem from "./CourseItem.vue";
import FilterTab from "../../components/layout/FilterTab.vue";

export default defineComponent({
  components: {
    Header,
    ContentContainer,
    CourseItem,
    AdComponent,
    ListTransition,
    FilterTab,
  },
  setup() {
    const store = useStore();
    /**
     *  State
     */
    const state = reactive({
      filters: [
        { id: 1, text: "Alle Kurse" },
        { id: 2, text: "Aktive" },
        { id: 3, text: "Abgeschlossene" },
        { id: 4, text: "Merkliste" },
      ],
      activeFilterId: 1,
    });

    /**
     *  Functions
     */

    async function FETCH_COURSES() {
      return store.dispatch(
        `${STORE_TYPES.COURSES}/${COURSE_TYPES.FETCH_COURSES}`
      );
    }
    /**
     *  Computed
     */
    const GET_COURSES = computed(
      () => store.getters[`${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSES}`]
    );

    const activeFilter = computed(() => {
      return state.filters.find((filter) => filter.id === state.activeFilterId);
    });

    const filteredCourses = computed(() => {
      const activeFilter = state.filters.find(
        (f) => f.id === state.activeFilterId
      );
      switch (activeFilter.id) {
        case 2: //Aktive
          return GET_COURSES.value.filter(
            (course) =>
              course.total_progress.total > 0 &&
              course.total_progress.total < 100
          );
        case 3: //Abgeschlossene
          return GET_COURSES.value.filter(
            (course) => course.total_progress.total == 100
          );
        case 4: //Merkliste
          return GET_COURSES.value.filter(
            (course) => course.is_remember == true
          );

        default:
          //alle
          return GET_COURSES.value;
      }
    });
    /**
     *  Created
     */

    store.commit(
      `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
      "isLoadingData"
    );
    Promise.all([FETCH_COURSES()]).then(() => {
      store.commit(
        `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
        "isLoadingData"
      );
    });

    return { state, filteredCourses, activeFilter };
  },
});
</script>
